import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import "./style.scss";
import Question from "../../containers/question/";
import {
  dataToJS,
  isLoaded,
  pathToJS,
  firebaseConnect
} from "react-redux-firebase";
import BlankPage from "../blank/";
import DrawerToggle from "../../containers/drawer-toggle/";
import CKEditor from "react-ckeditor-wrapper";
import Textarea from "react-textarea-autosize";
class EditLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null
    };
    this.updateDirections = this.updateDirections.bind(this);
    this.updateGroupTitle = this.updateGroupTitle.bind(this);
    this.updateQuestionTitle = this.updateQuestionTitle.bind(this);
    this.save = this.save.bind(this);
  }
  updateDirections(value) {
    this.state.log.directions = value;
    this.setState(this.state);
  }
  updateGroupTitle(groupIndex, event) {
    this.state.log.groups[groupIndex].title = event.target.value;
    this.setState(this.state);
  }
  updateQuestionTitle(groupIndex, questionIndex, event) {
    this.state.log.groups[groupIndex].questions[
      questionIndex
    ].title = event.target.value;
    this.setState(this.state);
  }

  componentWillUnmount() {}

  componentWillReceiveProps(props) {
    if (isLoaded(props.log)) this.state = { log: props.log };
  }

  save() {
    this.state.log.groups = this.state.log.groups.filter(group => group);
    this.props.firebase.set(
      `/logs/${this.props.match.params.logId}`,
      this.state.log
    );
    alert("saved");
  }

  render() {
    if (this.state.log) {
      return (
        <div className="flex-container">
          <div className="toolbar">
            <DrawerToggle /> <h1>{this.props.log.title}</h1><h1>
              <button onClick={this.save}>
                Save
              </button>
            </h1>
          </div>
          <div className="content log">
            <div className="page">
              <div className="max-width">
                <div className="max-width">
                  <div className="card">
                    <h2>Directions</h2>

                    <CKEditor
                      value={this.state.log.directions}
                      onChange={this.updateDirections}
                    />
                  </div>
                </div>
                {this.state.log.groups.map(
                  (group, groupIndex) =>
                    group &&
                    <div
                      key={
                        `${this.props.match.params.groupId}${this.props.match.params.logId}${groupIndex}`
                      }
                    >
                      <br />
                      <br />
                      <br />
                      <br />
                      <div className="card">
                        <h2>Section Title</h2>
                        <input
                          disabled={this.props.disabled}
                          type="text"
                          placeholder={"No Section Title"}
                          value={group.title}
                          onChange={e => this.updateGroupTitle(groupIndex, e)}
                        />
                      </div>
                      <br />
                      <div className="card">
                        {(group.questions || [])
                          .map((question, questionIndex) => {
                            switch (question.type) {
                              case "Free Response":
                                return (
                                  <div className={"flex-container"}>
                                    <h2>Free Response Title</h2>
                                    <Textarea
                                      disabled={this.props.disabled}
                                      type="text"
                                      placeholder={"No Section Title"}
                                      value={question.title}
                                      onChange={e =>
                                        this.updateQuestionTitle(
                                          groupIndex,
                                          questionIndex,
                                          e
                                        )}
                                    />
                                  </div>
                                );
                              case "Multiple Choice":
                                return (
                                  <div className={"flex-container"}>
                                    <h2>Multiple Choice Title</h2>
                                    <Textarea
                                      disabled={this.props.disabled}
                                      type="text"
                                      placeholder={"No Section Title"}
                                      value={question.title}
                                      onChange={e =>
                                        this.updateQuestionTitle(
                                          groupIndex,
                                          questionIndex,
                                          e
                                        )}
                                    />
                                  </div>
                                );
                              case "2":
                                return (
                                  <p>Favorite questions can not be modified.</p>
                                );
                            }
                          })}
                      </div>
                    </div>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return <BlankPage />;
    }
  }
}

export default withRouter(
  connect(({ firebase }, { match, auth }) => {
    return {
      log: dataToJS(firebase, `/logs/${match.params.logId}`)
    };
  })(
    firebaseConnect(({ match, auth }) => {
      return ["/logs"];
    })(EditLog)
  )
);



// WEBPACK FOOTER //
// ./src/routes/edit-log/index.js